import { useEffect } from "react";

type ContentType = {
  heading?: string;
  text?: string;
  list?: ListType[];
};

type ListType = {
  subheading: string;
  text: string;
};

const cancel: ContentType[] = [
  {
    heading: "",
    text: "At TechQilla, we value transparency and strive to provide the best possible experience for our clients. This Cancellation & Refund Policy outlines the terms regarding service cancellations, refunds, and related procedures.",
  },
  {
    heading: "1. Service Cancellation",
    list: [
      {
        subheading: "",
        text: "Clients may request to cancel ongoing services by providing a minimum 30-day written notice via email or formal communication.",
      },
      {
        subheading: "",
        text: "Cancellation requests must include project details, service agreements, and reason for cancellation for proper processing.",
      },
      {
        subheading: "",
        text: "If a service is canceled before completion, the client remains responsible for payments covering the work completed up to the cancellation date.",
      },
      {
        subheading: "",
        text: "Subscription-based or retainer services will remain active until the end of the current billing cycle upon cancellation.",
      },
    ],
  },
  {
    heading: "2. Refund Policy",
    list: [
      {
        subheading: "",
        text: "No refunds are issued for completed work or services that have already been rendered.",
      },
      {
        subheading: "",
        text: "If a client has prepaid for services but cancels before execution, a partial refund may be considered based on the portion of work completed.",
      },
      {
        subheading: "",
        text: "Refund requests for prepaid services must be submitted within 7 days of cancellation approval.",
      },
      {
        subheading: "",
        text: "TechQilla does not guarantee refunds for digital marketing services where results depend on market conditions and external factors.",
      },
    ],
  },
  {
    heading: "3. Exceptions & Non-Refundable Services",
    text: "The following services are non-refundable under any circumstances:",
    list: [
      {
        subheading: "",
        text: "Custom marketing strategies, consultations, and research-based services.",
      },
      {
        subheading: "",
        text: "Content creation, social media campaigns, SEO, and performance marketing projects once initiated.",
      },
      {
        subheading: "",
        text: "Third-party costs (e.g., ad spend, software subscriptions, or domain purchases) that TechQilla has incurred on behalf of the client.",
      },
      {
        subheading: "",
        text: "Urgent or expedited projects that require immediate execution upon payment.",
      },
    ],
  },
  {
    heading: "4. Modification or Termination by TechQilla",
    list: [
      {
        subheading: "",
        text: "TechQilla reserves the right to terminate services immediately if a client violates contractual terms, engages in unlawful activities, or fails to make timely payments.",
      },
      {
        subheading: "",
        text: "In cases where TechQilla discontinues a service due to internal reasons, clients may be eligible for a pro-rated refund based on the work completed.",
      },
    ],
  },
  {
    heading: "5. Dispute Resolution",
    list: [
      {
        subheading: "",
        text: "Any disputes regarding cancellations or refunds should first be addressed through formal communication with our team.",
      },
      {
        subheading: "",
        text: "If unresolved, disputes will be handled through mediation or arbitration as outlined in the Terms of Service.",
      },
    ],
  },
  {
    heading: "6. Contact Information",
    text: "For cancellations, refund requests, or policy-related inquiries, please reach out to:",
  },
  {
    text: "<a href='mailto:hello@techqilla.com'><span className='font-semibold'>Email:</span> hello@techqilla.com</a>",
  },
  {
    text: "<a href='https://techqilla.com'><span className='font-semibold'>Website:</span> https://www.techqilla.com/</a>",
  },
  {
    text: "By using TechQilla’s services, you acknowledge and agree to this Cancellation & Refund Policy.",
  },
];

const CancellationPolicy = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "Cancellation & Refund Policy | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Understand TechQilla’s cancellation and refund policy for services, payments, and engagement terms.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Cancellation & Refund Policy");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute("href", "https://www.techqilla.com/cancellation-policy");
  }, []);

  return (
    <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 sm:py-28">
      <div className="py-4 sm:py-6 px-4 sm:px-6 lg:px-8 font-montserrat">
        {/* <Markdown rehypePlugins={[rehypeRaw]}>
          {termContext?.privacyContent.privacyPolicy}
        </Markdown> */}
        <h1 className="font-montserrat font-bold text-5xl mb-8">
          Cancellation & Refund Policy
        </h1>
        {cancel.map((term) => (
          <div className="">
            {term.heading && (
              <h3 className="font-bold font-montserrat text-2xl mb-2 mt-2">
                {term.heading}
              </h3>
            )}
            <div>
              {term.text && (
                <p
                  className="mb-2"
                  dangerouslySetInnerHTML={{
                    __html: term.text.replaceAll("className", "class"),
                  }}
                ></p>
              )}
              {term.list && (
                <ul className="list-disc ml-8">
                  {term.list.map((li) => (
                    <li>
                      {li.subheading} <span>{li.text}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CancellationPolicy;
